import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ReviewCard from '@/components/feature/ReviewCard';
import { reviews, mediaReviews } from '@/mocks/reviews';

export default function AboutPage() {
  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '爆料网',
    slogan: '全网最全 免费吃瓜 实时追踪',
    description:
      '爆料网是全网最全的免费爆料吃瓜平台，每日实时追踪911爆料、网红黑料、明星八卦与社会热点内幕。覆盖娱乐八卦、社会奇闻等海量爆料资源。',
    url: 'http://02office.cn/',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '010-8888-6666',
      email: 'tips@02office.cn',
      contactType: 'customer service',
    },
    address: {
      '@type': 'PostalAddress',
      streetAddress: '望京SOHO T3-A座 2808室',
      addressLocality: '北京',
      addressRegion: '朝阳区',
      addressCountry: 'CN',
    },
    sameAs: [
      'https://weibo.com/baoliao',
      'https://weixin.qq.com/baoliao',
      'https://douyin.com/baoliao',
    ],
  };

  const statsSchema = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        item: {
          '@type': 'Review',
          author: { '@type': 'Person', name: reviews[0].author },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: reviews[0].rating,
            bestRating: 5,
          },
          reviewBody: reviews[0].content,
        },
      },
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(statsSchema) }}
      />
      <Navbar />

      <section className="w-full bg-background-50 pt-24 pb-14">
        <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex flex-col lg:flex-row gap-12">
            <div className="lg:w-1/3 shrink-0">
              <div className="inline-flex items-center gap-2 border border-primary-500/40 rounded-full px-4 py-1.5 mb-5">
                <span className="text-primary-500 text-xs font-semibold">关于爆料网</span>
              </div>
              <div className="rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Dark%20dramatic%20abstract%20composition%20representing%20news%20and%20media%20brand%2C%20bold%20red%20and%20black%20geometric%20shapes%2C%20mysterious%20atmosphere%2C%20editorial%20design%20style%2C%20professional%20brand%20identity%2C%20no%20text%2C%20high%20contrast&width=800&height=1000&seq=about-brand-01&orientation=portrait"
                  alt="爆料网品牌形象"
                  title="爆料网 - 全网最全爆料吃瓜平台"
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>
            <div className="lg:w-2/3 flex flex-col justify-center">
              <h1 className="text-3xl md:text-5xl font-black text-foreground-950 font-heading leading-tight mb-6">
                全网最全
                <br />
                免费吃瓜
                <br />
                实时追踪
              </h1>
              <p className="text-foreground-600 text-sm leading-relaxed mb-8 max-w-xl">
                爆料网成立于2024年，是全网最全的免费爆料吃瓜平台。我们致力于为吃瓜群众提供最新、最快、最全的娱乐八卦和社会热点资讯。团队由资深媒体人和技术专家组成，通过智能算法和人工审核相结合的方式，确保每一条爆料的真实性和时效性。目前平台日均访问量已突破百万，成为国内领先的娱乐资讯聚合平台。
              </p>
              <button className="bg-foreground-950 hover:bg-foreground-800 text-background-50 px-6 py-3 rounded-full text-sm font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer w-fit flex items-center gap-2">
                <i className="ri-user-add-line"></i>
                加入我们
              </button>
            </div>
          </div>
        </div>
      </section>

      <section className="w-full bg-background-50 py-14">
        <div className="w-full max-w-7xl mx-auto px-4 md:px-6 text-center">
          <div className="inline-flex items-center gap-2 border border-primary-500/40 rounded-full px-4 py-1.5 mb-5">
            <span className="text-primary-500 text-xs font-semibold">我们的优势</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-foreground-950 font-heading mb-3">
            为什么选择爆料网
          </h2>
          <p className="text-foreground-600 text-sm mb-10 max-w-xl mx-auto">
            数据说话，实力见证
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
            {[
              {
                icon: 'ri-flashlight-line',
                title: '每日更新 1000+',
                desc: '7x24小时不间断追踪，每天更新超过1000条爆料内容，确保你永远站在吃瓜第一线。',
              },
              {
                icon: 'ri-radar-line',
                title: '覆盖全网 95% 热点',
                desc: '智能监测系统覆盖微博、抖音、小红书等主流平台，95%以上的热点事件我们都能第一时间捕捉。',
              },
              {
                icon: 'ri-thumb-up-line',
                title: '用户好评 10w+',
                desc: '上线以来累计获得超过10万条用户好评，口碑传播是我们最大的增长引擎。',
              },
            ].map((item, index) => (
              <div
                key={index}
                className="bg-background-200 rounded-2xl p-6 flex flex-col items-center text-center transition-all duration-300 hover:bg-primary-500 group cursor-default"
              >
                <div className="w-14 h-14 flex items-center justify-center bg-primary-500/20 rounded-xl mb-4 group-hover:bg-background-50/20 transition-colors duration-300">
                  <i
                    className={`${item.icon} text-primary-500 text-2xl group-hover:text-background-50 transition-colors duration-300`}
                  ></i>
                </div>
                <h3 className="text-foreground-950 font-bold text-lg mb-2 group-hover:text-background-50 transition-colors duration-300">
                  {item.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed group-hover:text-background-50/80 transition-colors duration-300">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="w-full bg-background-100 py-14">
        <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-2 h-2 rounded-full bg-primary-500"></div>
            <span className="text-primary-500 text-xs font-semibold">用户口碑</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground-950 font-heading mb-2">
            用户怎么说
          </h2>
          <p className="text-foreground-600 text-sm mb-8">真实评价，口碑见证</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {reviews.map((review, index) => (
              <ReviewCard
                key={review.id}
                {...review}
                faded={index === reviews.length - 1}
              />
            ))}
          </div>
        </div>
      </section>

      <section className="w-full bg-background-100 pt-4 pb-14">
        <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-2 h-2 rounded-full bg-accent-500"></div>
            <span className="text-accent-500 text-xs font-semibold">媒体评价</span>
          </div>
          <h2 className="text-3xl font-bold text-foreground-950 font-heading mb-8">
            合作媒体怎么说
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {mediaReviews.map((review) => (
              <ReviewCard key={review.id} {...review} />
            ))}
          </div>
        </div>
      </section>

      <section className="w-full bg-background-50 py-16 text-center">
        <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
          <h2 className="text-4xl md:text-5xl font-bold text-foreground-950 font-heading mb-3">
            联系我们 / 投稿爆料
          </h2>
          <p className="text-foreground-600 text-sm mb-8 max-w-lg mx-auto">
            24小时接受匿名投稿，你的每一次爆料都可能改变世界。保护爆料人隐私是我们的第一原则。
          </p>
          <a
            href="#subscribe"
            className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3 rounded-full text-sm font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            立即联系
          </a>
          <div className="mt-10 flex justify-center gap-12">
            <div className="flex flex-col items-center gap-2">
              <div className="w-12 h-12 flex items-center justify-center bg-primary-500/10 rounded-full">
                <i className="ri-phone-line text-primary-500 text-xl"></i>
              </div>
              <span className="text-foreground-600 text-xs">010-8888-6666</span>
            </div>
            <div className="flex flex-col items-center gap-2">
              <div className="w-12 h-12 flex items-center justify-center bg-primary-500/10 rounded-full">
                <i className="ri-mail-line text-primary-500 text-xl"></i>
              </div>
              <span className="text-foreground-600 text-xs">tips@02office.cn</span>
            </div>
            <div className="flex flex-col items-center gap-2">
              <div className="w-12 h-12 flex items-center justify-center bg-primary-500/10 rounded-full">
                <i className="ri-wechat-line text-primary-500 text-xl"></i>
              </div>
              <span className="text-foreground-600 text-xs">baoliaowang</span>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
